const appRoutes = {
  Dashboard: { path: "/" },
  UserDetails: { path: "/users" },
  Login: { path: "/account/login" },
};

export default appRoutes;
